import type {WebappCurrentUser} from '@dokia/strapi/types';

import {type LawType} from '@dokia/domain-model';

export type StoreAction =
  | {payload: {accessToken: string}; type: 'SET_APP_LOGIN';}
  | {payload: {
    selectedDomain: LawType;
  }; type: 'SET_SELECTED_DOMAIN';}
  | {payload: {user: WebappCurrentUser}; type: 'SET_USER';}
  | {type: 'CLEAR_USER'}
  | {type: 'SET_APP_INITIALIZED'}
  | {type: 'SET_APP_LOGOUT'}

export type StoreState = {
  accessToken: string | undefined;
  isAuthenticated: boolean;
  isInitializing: boolean;
  selectedDomain: LawType;
  user: undefined | WebappCurrentUser;
};
  
export const storeReducer = (
  state: StoreState,
  action: StoreAction,
): StoreState => {
  switch (action.type) {
  case 'CLEAR_USER': {
    return {
      ...state,
      user: undefined,
    };
  }
  case 'SET_APP_INITIALIZED': {
    return {
      ...state,
      isInitializing: false,
    };
  }
  case 'SET_APP_LOGIN': {
    return {
      ...state,
      accessToken: action.payload.accessToken,
      isAuthenticated: true,
      isInitializing: false,
    };
  }
  case 'SET_APP_LOGOUT': {
    return {
      ...state,
      accessToken: undefined,
      isAuthenticated: false,
      isInitializing: false,
      user: undefined,
    };
  }
  case 'SET_SELECTED_DOMAIN': {
    return {
      ...state,
      selectedDomain: action.payload.selectedDomain,
    };
  }
  case 'SET_USER': {
    return {
      ...state,
      user: action.payload.user,
    };
  }
  default: {
    return state;
  }
  }
};
